import { diff, valid } from "semver";

/**
 * Determines if a version change requires the user to be logged out.
 * Only major version changes require logout.
 *
 * @param oldVersion - The previous version (e.g., from persisted state)
 * @param newVersion - The current version (e.g., from environment)
 * @returns true if the version change requires logout, false otherwise
 */
export function requiresLogout(
  oldVersion: string | null,
  newVersion: string | null,
): boolean {
  if (!oldVersion || !newVersion) {
    return false;
  }

  if (!valid(oldVersion) || !valid(newVersion)) {
    return false;
  }

  return diff(oldVersion, newVersion) === "major";
}

/**
 * Gets the current application version from environment variables.
 *
 * @returns The current semantic version string, or null if not set
 */
export function getCurrentVersion(): string | null {
  return process.env.REACT_APP_SEMANTIC_VERSION ?? null;
}
